import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import heroImage from '../assets/images/aboutHero.png';
import ach1 from '../assets/images/ach1.jpg';
import ach2 from '../assets/images/ach2.jpg';
import ach3 from '../assets/images/ach3.jpg';
import ach4 from '../assets/images/ach4.jpg';
import ach5 from '../assets/images/ach5.jpg';
import ach6 from '../assets/images/ach6.jpg';

import '../styles/Pages.css';

const Achievements = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const images = [ach1, ach2, ach3, ach4, ach5, ach6];

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Achievements</h1>
            <p>Our Success Stories</p>
          </div>
        </div>
      </section>

      {/* IMAGES GRID */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '32px', color: '#0066cc', marginBottom: '50px', textAlign: 'center', fontWeight: 'bold' }}>
            Our Major Achievements
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '30px', marginTop: '40px' }}>
            {images.map((img, index) => (
              <div key={index} style={{ 
                overflow: 'hidden', 
                borderRadius: '8px', 
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)', 
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
              }}
              >
                <img 
                  src={img} 
                  alt={`Achievement ${index + 1}`}
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    aspectRatio: '1', 
                    objectFit: 'cover', 
                    display: 'block',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MOBILE RESPONSIVE */}
      <style>{`
        @media (max-width: 1024px) {
          .img-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 768px) {
          .img-grid {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Achievements;